import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, inject, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { PanZoomTemplateService } from './pan-zoom-template.service';
import { CommonModule } from '@angular/common';
import { PanZoomStatus } from '../../pan-zoom-staus.model';
import { PanZoomActionEnum } from '../../pan-zoom-action.enum';
import { TranslateModule } from '@ngx-translate/core';
import { PanZoomService } from '../../pan-zoom.service';

@Component({
  standalone: true,
  selector: 'lib-pan-zoom',
  imports: [CommonModule, TranslateModule],
  providers: [PanZoomTemplateService, PanZoomService],
  templateUrl: './pan-zoom.component.html',
  styleUrl: './pan-zoom.component.scss'
})
export class PanZoomComponent implements OnInit, AfterViewInit {
  @Input() public customContent!: TemplateRef<HTMLElement>;
  @Input() public customMiniatureContent!: TemplateRef<HTMLElement>;
  @Input() public customMiniatureHeader!: TemplateRef<HTMLElement>;
  @Input() public customMiniatureFooter!: TemplateRef<HTMLElement>;
  @Input() scrollOffset = 0;
  @Input() zoomLevel = 1;
  @Input() maxZoomLevel = 2;
  @Input() minZoomLevel = 1;

  @Input() zoomControlsAriaLabel = 'Zoom control';
  @Input() zoomInAriaLabel = 'Zoom in';
  @Input() zoomOutAriaLabel = 'Zoom out';
  @Input() maxMiniatureWidth = 200;

  @Output() zoomStatusChange = new EventEmitter<PanZoomStatus>();

  @ViewChild('viewerContainer') viewerContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('mainView') mainView!: ElementRef<HTMLDivElement>;
  @ViewChild('mainContent') mainContent!: ElementRef<HTMLDivElement>;
  @ViewChild('viewportIndicator') viewportIndicator!: ElementRef<HTMLDivElement>;
  @ViewChild('miniView') miniView!: ElementRef<HTMLDivElement>;
  @ViewChild('miniContent') miniContent!: ElementRef<HTMLDivElement>;

  public customTemplates = inject(PanZoomTemplateService);
  public panZoomService = inject(PanZoomService);

  ngOnInit() {
    this.customTemplates.init({
      customContent: this.customContent,
      customMiniatureContent: this.customMiniatureContent,
      customMiniatureHeader: this.customMiniatureHeader,
      customMiniatureFooter: this.customMiniatureFooter
    });
  }

  ngAfterViewInit() {
    this.panZoomService.init(
      {
        viewerContainer: this.viewerContainer,
        mainView: this.mainView,
        mainContent: this.mainContent,
        viewportIndicator: this.viewportIndicator,
        miniView: this.miniView,
        miniContent: this.miniContent
      },
      {
        zoomLevel: this.zoomLevel,
        maxZoomLevel: this.maxZoomLevel,
        minZoomLevel: this.minZoomLevel,
        scrollOffset: this.scrollOffset,
        maxMiniatureWidth: this.maxMiniatureWidth
      },
      this.zoomStatusChange
    );
  }

  ngOnDestroy() {
    this.panZoomService.destroy();
  }

  onMove(direction: 'up' | 'down' | 'left' | 'right') {
    this.panZoomService.move(direction);
  }

  onZoom(inOut: 'in' | 'out') {
    this.panZoomService.zoom(inOut);
  }

  onScroll() {
    this.panZoomService.updateOnScroll();
  }

  reinitViewport() {
    this.panZoomService.initViewport();
  }
}
